import React from 'react'
import PropTypes from 'prop-types'
import {List, ListItem} from '@chakra-ui/react'

const AddressDisplay = ({address, as: Component = List}) => (
    <Component>
        <ListItem>{address.address1}</ListItem>
        <ListItem>
            {[address.city, address.stateCode, address.postalCode].filter(Boolean).join(', ')}
        </ListItem>
    </Component>
)

AddressDisplay.propTypes = {
    address: PropTypes.object.isRequired,
    as: PropTypes.elementType
}

export default AddressDisplay
